// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo{width:auto;fill:#005baa}.logo--standard{height:24px}.logo--small{height:25px}.logo__wrapper{text-indent:-9999px;display:flex;align-items:center}.logo__blackfriday{height:50px;width:100%;max-width:108px;-o-object-fit:contain;object-fit:contain}@media (max-width:1024px){.logo__blackfriday{max-width:150px;height:40px;margin-top:5px}}@media (min-width:992px){.logo--standard{height:36px}.logo--small{height:25px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
